export const REPORT_PAGE_TITLES = {
  '/': 'titles.home',
  '/partner': 'titles.home',
  '/overview': 'titles.bodyHealthInfo',
  '/assess': 'titles.assess',
  '/scheme': 'titles.scheme',
  '/details': 'titles.details',
  '/recuperate': 'titles.recuperate',
  '/nutritions': 'titles.nutritions',
  '/nutrition': 'titles.nutrition',
  '/tissue': 'titles.tissue',
  '/compare': 'titles.compare',
  '/condition': 'titles.condition',
  '/monthly-report': 'reportNavigation.monthlyReport',
  '/tongue-report': 'reportNavigation.tongueReport',
  '/tongue-report.html': 'reportNavigation.tongueReport'
};

const REPORT_QUERY_KEYS = [
  'packageNo', 'serial_number', 'checkcode', 'rand', 'lang', 'pro',
  'schemeAssess', 'customSolution', 'platform', 'isThirdParty', 'source', 'hideShare',
  'hideReportNavigation'
];
const HISTORY_KEY = 'reportNavigation';

function hasQueryValue(route, key, expected) {
  if (!route || !route.query) return false;
  const value = route.query[key];
  return Array.isArray(value) ? value.includes(expected) : value === expected;
}

export function isDesktopWechatDevice(device = {}) {
  const userAgent = device.userAgent || '';
  const platform = device.platform || '';
  const clientPlatform = device.userAgentData && device.userAgentData.platform || '';
  if (!/micromessenger/i.test(userAgent)) return false;
  if (/android|iphone|ipad|ipod|mobile|windows phone|harmonyos/i.test(userAgent) ||
    /android|ios|ipados/i.test(clientPlatform)) return false;
  if (/mac/i.test(`${userAgent} ${platform} ${clientPlatform}`) && device.maxTouchPoints > 1) {
    return false;
  }
  return /windowswechat|macwechat|windows nt|macintosh|mac os x/i.test(userAgent) ||
    /^(win32|win64|windows|mac)/i.test(platform) || /^(windows|macos)$/i.test(clientPlatform);
}

export function shouldHideReportNavigation({ nativeApp, route, device }) {
  if (nativeApp) return true;
  if (hasQueryValue(route, 'hideReportNavigation', '1')) return true;
  return !isDesktopWechatDevice(device);
}

export function preserveReportNavigationFlag(to, from) {
  if (!hasQueryValue(from, 'hideReportNavigation', '1') ||
    to.query.hideReportNavigation !== undefined) return to;
  return { ...to, query: { ...to.query, hideReportNavigation: '1' } };
}

function isReportRoute(route) {
  return !!route && Object.prototype.hasOwnProperty.call(REPORT_PAGE_TITLES, route.path);
}

function isSameReport(first, second) {
  if (!isReportRoute(first) || !isReportRoute(second)) return false;
  const firstId = first.query.packageNo || first.query.serial_number;
  const secondId = second.query.packageNo || second.query.serial_number;
  return typeof firstId === 'string' && firstId !== '' && firstId === secondId;
}

export function getReportHome(route, thirdPartyMode) {
  const query = {};
  REPORT_QUERY_KEYS.forEach(key => {
    if (route.query[key] !== undefined) query[key] = route.query[key];
  });
  if (!query.packageNo && query.serial_number) query.packageNo = query.serial_number;
  return { path: thirdPartyMode ? '/partner' : '/', query };
}

export function installReportNavigation(router, browser = window) {
  return router.afterEach((to, from) => {
    Promise.resolve().then(() => {
      if (router.currentRoute.fullPath !== to.fullPath || !isReportRoute(to)) return;
      const state = browser.history.state || {};
      const entry = state[HISTORY_KEY];
      if (entry && entry.fullPath === to.fullPath) return;
      let previous = null;
      if (isSameReport(from, to)) {
        previous = entry && entry.fullPath === from.fullPath ? entry.previous : from.fullPath;
      }
      try {
        browser.history.replaceState({
          ...state,
          [HISTORY_KEY]: { fullPath: to.fullPath, previous }
        }, '');
      } catch (error) {
        console.warn('[ReportNavigation] 无法记录报告导航，将使用报告首页兜底', error);
      }
    });
  });
}

export function canGoBackInReport(router, browser = window) {
  const route = router.currentRoute;
  const entry = browser.history.state && browser.history.state[HISTORY_KEY];
  if (!entry || entry.fullPath !== route.fullPath || !entry.previous) return false;
  const previous = router.resolve(entry.previous).route;
  return isSameReport(route, previous);
}
